export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('ECH_DATE_START_GREATER_THAN_END_DATE') !== -1) {
      messages.push({ message: 'echeancierFacturation.messages.errors.startGreaterThanEnd' });
    }
    if (message.indexOf('ECH_FIRST_ENDDATE_OUTSIDE_RANGE') !== -1) {
      messages.push({ message: 'echeancierFacturation.messages.errors.firstEndDateOutsideRange' });
    }
    if (message.indexOf('POURCENTAGE_DIVISION') !== -1) {
      messages.push({ message: 'echeancierFacturation.messages.errors.pourcentageDivision' });
    }
    if (message.indexOf('NOT_SAME_DIVISION_TYPE') !== -1) {
      messages.push({ message: 'echeancierFacturation.messages.errors.divisionType' });
    }
    if (message.indexOf('ECHEANCIERLIGNE_NEED_A_PAYER') !== -1) {
      messages.push({ message: 'echeancierFacturation.messages.errors.payer' });
    }
  });
}
